// Live digital clock. Shows 12-hour time HH:MM:SS with AM/PM in small.
import { useEffect, useState } from "react";

export default function DigitalClock({ className = "" }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  let h = now.getHours();
  const m = String(now.getMinutes()).padStart(2, "0");
  const s = String(now.getSeconds()).padStart(2, "0");
  const period = h >= 12 ? "PM" : "AM";
  h = h % 12;
  if (h === 0) h = 12;

  return (
    <div
      className={`inline-flex items-baseline gap-2 font-en tabular-nums ${className}`}
      data-testid="digital-clock"
      aria-label={`Current time ${h}:${m}:${s} ${period}`}
    >
      <span className="text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight leading-none">
        {h}:{m}
        <span className="text-slate-400">:{s}</span>
      </span>
      <span className="text-xs font-semibold text-slate-500 tracking-widest">
        {period}
      </span>
    </div>
  );
}
